export const PAGE_TABS_COMPONENT = Symbol('PAGE_TABS_COMPONENT')

export const PAGE_URL_PARAMS = Symbol('PAGE_URL_PARAMS')
